import React from "react";
import LegalLayout from "../components/LegalLayout";
import { privacyContent } from "../data/privacyPolicyContent";

const PrivacyPolicyPage = () => (
  <LegalLayout
    label="Legal"
    title="Privacy Policy"
    subtitle="We value your privacy and aim to handle your data responsibly, transparently, and securely."
    intro="At O3S, we value your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our services and website."
    sections={privacyContent}
    contactText="Questions regarding privacy or data handling?"
    variant="privacy"
  />
);

export default PrivacyPolicyPage;
